module.exports = __webpack_public_path__ + "/login_ui/img/dj-5216627ab96f6ff8118117794c94b540.svg";